import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FolderNode } from '@shared/layout/sidebar-menu/folder-menu/folder-menu.datasource';
import { ModalService } from '@shared/modal/modal.service';
import { EncryptionHelperService } from '@shared/services/encryption-helper.service';
import { ScopeService } from '@shared/services/scope.service';
import { Scope } from '@shared/types/scope';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AccountE2eEncryption } from './../../api/types/account';

@Component({
  selector: 'rav-new-button',
  templateUrl: './new-button.component.html',
  styleUrls: ['./new-button.component.scss']
})
export class NewButtonComponent {
  @Input() isSidebarCollapsed: boolean;

  isCreateFolders = false;
  selectedFolder: FolderNode;

  isProcessing: boolean;
  canImport: boolean;
  canCreateFolders: boolean;
  canCreateTemplate: boolean;
  canImportFolder: boolean;

  constructor(
    public modal: ModalService,
    public router: Router,
    public scope: ScopeService,
    private deviceService: DeviceDetectorService,
    private e2eEncryptionHelper: EncryptionHelperService
  ) {
    this.e2eEncryptionHelper.accountEncryptionStatus.subscribe((status) => {
      this.isProcessing = status === AccountE2eEncryption.Activating || status === AccountE2eEncryption.Deactivating;
    });
    this.canImport = scope.hasAccess(Scope.DocumentWrite);
    this.canCreateFolders = scope.hasAccess(Scope.FolderWrite);
    this.canCreateTemplate = scope.hasAccess(Scope.TemplateWrite);
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.canImportFolder = !(
      this.deviceService.isMobile() ||
      this.deviceService.isTablet() ||
      deviceInfo.browser === 'IE'
    );
  }
}
